import { render } from "./designReferenceFormSelectPrint.vue?vue&type=template&id=9dd25f8e"
import script from "./designReferenceFormSelectPrint.vue?vue&type=script&lang=js"
export * from "./designReferenceFormSelectPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__